import { PPD_SET_ACTIVE_TAB } from '~/frontend/src/constants';

export type SetActiveTabIndexAction = {
    type: typeof PPD_SET_ACTIVE_TAB;
    panelKey: string;
    activeTabIndex: number;
}
/**
 * @memberOf! Actions
 *
 * @param {String} panelKey
 * @param {Number} activeTabIndex
 *
 * @return {setActiveTabIndex}
 */
export const setActiveTabIndex = ( panelKey: string, activeTabIndex: number ): SetActiveTabIndexAction => {
    return {
        type: PPD_SET_ACTIVE_TAB,
        panelKey,
        activeTabIndex
    };
}

import { PPD_CLEAR_STATE } from '~/frontend/src/constants';

export type ClearStateAction = {
    type: typeof PPD_CLEAR_STATE;
    panelKey: string;
}
/**
 * @memberOf! Actions
 *
 * @param {String} panelKey
 *
 * @return {ClearStateAction}
 */
export const clearState = ( panelKey: string ): ClearStateAction => {
    return {
        type: PPD_CLEAR_STATE,
        panelKey
    };
}
